import { SaplingModule } from './sapling-sdk.min.js';

export const Sapling = SaplingModule.SaplingModule;
